import PropTypes from 'prop-types';
import React from 'react';
import {Pagination as PaginationComp} from 'react-bootstrap';
import '../../assets/css/datatable.css';

const PaginationLoadMore = ({previousPage, nextPage, hasMore, pageIndex}) => {

  return (
    <PaginationComp className="PaginationComp">
      {/*Previous Button*/}
      {pageIndex > 0 &&
      <PaginationComp.Prev
        onClick={previousPage}
        className="link-next"/>
      }

      {/*Next Page Button*/}
      {hasMore &&
        <PaginationComp.Next
          onClick={nextPage}
          className="link-next"/>
      }

    </PaginationComp>
  );
};

PaginationLoadMore.propTypes = {
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  pageIndex: PropTypes.number.isRequired,
};

export default PaginationLoadMore;
